/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'error': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="#FF334E" stroke-width="2" _fill="none" fill-rule="evenodd"><circle pid="0" cx="16" cy="16" r="15"/><path pid="1" d="M21 11L11 21M11 11l10 10"/></g>'
  }
})
